import React from 'react';

import { Footer as FlixFooter } from '@flixbus/honeycomb-react';

const Footer = () => (
  <FlixFooter fullwidth style={{ padding: 0 }}>
    <></>
  </FlixFooter>
);

export default Footer;
